import React from "react";
import { CreditCard } from "@mui/icons-material";
import { Box, Typography, Button } from "@mui/material";
import { usePayment, useTheme } from "../hooks";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getContrastTextColor } from "../utils/colorManager";
import { swapToDefaultServiceLogo } from "../constants";
import { usePortal } from "../context/portalContext";
interface MerchantInfoProps {
  borderColor: string;
  merchantName: string;
  logoSrc?: string;
}

const MerchantInfo: React.FC<MerchantInfoProps> = ({
  borderColor,
  merchantName,
  logoSrc,
}) => {
  const { currentStep } = usePayment();
  const { theme } = useTheme();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { scope, targetServiceId, homePath } = usePortal();
  // A link made for one service has no list behind it: its start page opens
  // this same step again, so the way back is not offered. Both halves are
  // needed -- a page can be scoped to a service and still list services.
  const hasServiceList = !(scope?.type === "SERVICE" && targetServiceId);

  return (
    <Box
      sx={{
        bgcolor: "white",
        border: 1,
        borderColor: borderColor,
        borderBottom: "none",
        borderRadius: 1,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        p: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center" }}>
        {logoSrc ? (
          <img
            src={logoSrc}
            alt={merchantName}
            onError={swapToDefaultServiceLogo}
            style={{ width: 62, marginRight: 15 }}
          />
        ) : (
          <CreditCard sx={{ width: 62, height: 24, color: "#d97706", mr: 5 }} />
        )}
        <Typography
          variant="h6"
          fontWeight="bold"
          color={getContrastTextColor("white")}
        >
          {merchantName}
        </Typography>
      </Box>
      {currentStep === 1 && hasServiceList && (
        <Button
          variant="contained"
          onClick={() => navigate(homePath)}
          sx={{
            bgcolor: theme.color_primary,
            "&:hover": {
              bgcolor: "amber.200",
            },
          }}
        >
          <Typography color={getContrastTextColor(theme.color_primary)}>
            {t("payment.change_service")}
          </Typography>{" "}
        </Button>
      )}
    </Box>
  );
};

export default MerchantInfo;
